import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../api';

export default function Dashboard({ token, user }) {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/me`, { headers: { Authorization: token } })
      .then((res) => res.json())
      .then(setProfile)
      .catch(() => setProfile(null));
  }, [token]);

  return (
    <div className="container">
      <h2>Dashboard</h2>
      {user && <p>Signed in as <b>{user.name}</b> ({user.role})</p>}
      {user?.organization_name && <p>Organization: <b>{user.organization_name}</b></p>}
      {profile?.blocked_at && <p className="blockedBanner">Your profile is blocked. You can still access previous receipts, but new receipt activity is disabled.</p>}
      {user?.role === 'buyer' && !profile?.blocked_at && <Link to="/create"><button>Create Receipt</button></Link>}
      {['admin', 'buyer', 'farmer'].includes(user?.role) && <Link to="/receipts"><button>View Receipts</button></Link>}
      {['admin', 'buyer', 'farmer'].includes(user?.role) && <Link to="/product-data"><button>Product Data</button></Link>}
      {['buyer', 'farmer'].includes(user?.role) && <Link to="/profile"><button>My Profile</button></Link>}
      {user?.role === 'admin' && <Link to="/admin"><button>Admin</button></Link>}
      {user?.role === 'admin' && <Link to="/admin/profiles"><button>Create Profiles</button></Link>}
      {user?.role === 'superadmin' && <Link to="/superadmin"><button>Manage Organizations</button></Link>}
      {user?.role === 'farmer' && <p>Open Receipts to see receipts issued to you, including QR codes and hashes.</p>}
      {!user && <p>Please log in to access your dashboard.</p>}
    </div>
  );
}
